import { Outlet, useLocation } from 'react-router-dom'
import { Toasts } from '../features/toasts/toasts.tsx'
import { Menu } from '../features/rightmenu/menu.tsx'
import { useIsMobile } from '../shared/lib/hooks.ts'
import { cn } from '../shared/lib/utils.ts'
import { Navbar } from '../features/navbar/navbar.tsx'
import { MainContainer } from '../shared/ui/card/card.tsx'
import { useAppModule } from '../features/appContext.ts'
import { SubscribeButton } from '../features/subscribeButton/subscribeButton.tsx'
import { urls } from '../shared/urls.ts'

const NAVBAR_EXCEPTIONS = ['/payment', urls.myCourses]

export function Layout(props: {
  withMenu: boolean
  withNavbar: boolean
  fullWidth?: boolean
  scroll?: boolean
  white?: boolean
  customContainer?: boolean
  mainContainer?: boolean
}) {
  const location = useLocation()
  const isMobile = useIsMobile()
  const authStore = useAppModule().authStore
  const isException = NAVBAR_EXCEPTIONS.some((exception) =>
    location.pathname.includes(exception),
  )
  const showDesktopMenu =
    !isMobile && ((props.withNavbar && !isException) || props.withMenu)
  const showMobileNavbar = props.withNavbar && !isException && isMobile
  const contentMaxClass = 'max-w-1000 2xl:max-w-1300'
  const enableMainContainer =
    !props.customContainer && props.withNavbar && !isMobile
  const subscribeButton =
    !authStore.state.isActiveSubscribe && props.mainContainer ? (
      <SubscribeButton />
    ) : null

  return (
    <div
      className={cn(
        'w-full [scrollbar-width:thin]',
        props.white ? 'bg-white xl:bg-bglight' : 'bg-light xl:bg-bglight',
      )}
    >
      {showMobileNavbar ? <Navbar /> : null}
      {showDesktopMenu ? (
        <div className="flex min-h-dvh justify-center gap-24 px-24 2xl:gap-40 2xl:px-48">
          <Menu />
          <div className={cn('relative min-w-0 flex-1', contentMaxClass)}>
            <MainContainer enable={enableMainContainer}>
              {subscribeButton}
              <Outlet />
            </MainContainer>
          </div>
        </div>
      ) : (
        <div className="relative flex min-h-dvh">
          <MainContainer enable={false}>
            {subscribeButton}
            <Outlet />
          </MainContainer>
        </div>
      )}
      <Toasts />
    </div>
  )
}
